import React from 'react';
import { Form, Header, Message, Button, Segment, Icon, Label, Image } from 'semantic-ui-react';
import UploadFile from './UploadFile.js'
import { buildObjectsArr } from '../../helper/helper.js';
import admHOC from './admHOC.js';

class AdmFormAction extends React.Component {

  render() {

    const { formValues, formFieldValidity, submitAttempted, keyEditable } = this.props;
    const disableButtons = this.props.processing || !formFieldValidity._form || !formValues.key;

    const requirements = buildObjectsArr(this.props.requirements);
    const howtos = buildObjectsArr(this.props.howtos);
    const channels = buildObjectsArr(this.props.channels);
    const optnRequirements = requirements.map( req =>  ({text: req.key, value: req.key}) );
    const optnHowtos = howtos.map( howTo =>  ({text: howTo.key, value: howTo.key}) );
    const optnChannels = channels.map( howTo =>  ({text: howTo.name, value: howTo.key}) );

    const fanoutObj = {
      parentPath: 'channels',
      child: formValues.chanId,
      endpoint: 'actionId',
      data: formValues.key
    };

    return (
      <Form as='form'
        error={!formFieldValidity._form}
        onReset={this.props.handleReset}
        onSubmit={ (e) => {
          this.props.handleSubmit('actions', e, [fanoutObj]);
        }}>
        <Header dividing>
          <Icon name='lightbulb'/>
          <Header.Content>Action</Header.Content>
          <Header.Subheader>Add, Edit or Delete</Header.Subheader>
        </Header>

        <Form.Input required name='key' label='Key'
          readOnly={!keyEditable}
          onChange={this.props.handleChange}
          error={!formFieldValidity.key && submitAttempted}
          value={formValues.key}
          placeholder='Key required, please choose on the left or click "add new"'
        />

        <Form.Checkbox name='published' label='published'
          checked={formValues.published}
          disabled
        />

        <Form.Select search required
          label='Channel' name='chanId' placeholder='Channel...'
          options={optnChannels}
          value={formValues.chanId}
          onChange={this.props.handleChange}
        />

        <Form.Input required name='name' label='Name'
          onChange={this.props.handleChange}
          error={!formFieldValidity.name && submitAttempted}
          value={formValues.name}
        />

        <UploadFile
          showProgressBar
          disabled={disableButtons}
          getUploadData={this.props.handleChange}
          resetEval={formValues.key}
          fieldName='imgUrl'
          />

        <Form.Input required name='imgUrl' label='Screenshot URL'
          onChange={this.props.handleChange}
          error={!formFieldValidity.imgUrl && submitAttempted}
          value={formValues.imgUrl}
        />
        <Segment width={8} compact> <Image size='small' src={formValues.imgUrl} /> </Segment>

        <Form.TextArea required name='descr' label='Description'
          onChange={this.props.handleChange}
          error={!formFieldValidity.descr && submitAttempted}
          value={formValues.descr}
        />

        <Form.Group className='formGroup'>
          <Form.Input required width={12} name='url' label='Slug URL (must be unique)'
            onChange={this.props.handleChange}
            error={!formFieldValidity.url && submitAttempted}
            value={formValues.url} />
          { (this.props.checkIsUnique('actions', 'url', formValues.url))
            ? <Label basic pointing='left'><Icon name='check circle' color='green'/>Unique</Label>
            : <Label basic pointing='left' color='red'><Icon name='warning circle' color='red'  />in Use!</Label> }
        </Form.Group>

        <Form.Select search multiple disabled
          label='Requirements' name='reqIds' placeholder='Requirements...'
          options={optnRequirements}
          value={ formValues.reqIds  || [] }
          onChange={this.props.handleChange}
        />

        <Form.Select search multiple disabled
          label='How Tos' name='howtos' placeholder='How Tos...'
          options={optnHowtos}
          value={ formValues.howToIds  || [] }
          onChange={this.props.handleChange}
        />

        <Message error className='formMsg'>
          <Message.Header>You shall not pass!</Message.Header>
          <Message.List items={formFieldValidity._msgList} />
        </Message>

        <Button color='red' icon='trash' basic
          type='button'
          disabled={disableButtons}
          onClick={ (e) => this.props.confirmDeletion('actions', e, [], [fanoutObj]) }
        />

        <Button.Group >
          <Button
            basic
            color='grey'
            type='reset'>
            Reset Form
          </Button>
          <Button
            primary
            disabled={disableButtons}
            type='submit'
            >
            Submit
          </Button>
        </Button.Group>

      </Form>
    );
  }

}

export default admHOC(AdmFormAction);



// WEBPACK FOOTER //
// ./src/components/forms/AdmFormAction.js